import React, { Component } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import MetisMenu from "metismenujs";
import { connect } from "react-redux";
import { toggleSidebar } from "../../store/actions";
import { makeLayoutSelectField } from "store/layout/selector";

const data = [
  { link: "/dashboard", icon: "fa fa-tachometer-alt", title: "Dashboard" },
  { link: "/category", icon: "fa fa-th-large", title: "Category" },
  { link: "/subcategory", icon: "fa fa-th", title: "Sub Category" },
  { link: "/productcategory", icon: "fa fa-th", title: "Product Category" },
  { link: "/product", icon: "fa fa-box-open", title: "Products" },
  { link: "/order", icon: "fa fa-clipboard-list", title: "Orders" },
  { link: "/slip", icon: "fa fa-clipboard-list", title: "Product Slip" },
  { link: "/offer", icon: "fa fa-tag", title: "Offers" },
  { link: "/coupon", icon: "fa fa-bookmark", title: "Coupons" },
  { link: "/deliverycharges", icon: "fa fa-truck", title: "Delivery Charges" },
  { link: "/user", icon: "fa fa-users", title: "Users" },
];

const SideNav = () => {
  return (
    <div id="sidebar-menu">
      <ul className="metismenu" id="side-menu">
        {data.map((d, index) => (
          <li key={index}>
            <Link to={d.link} className="waves-effect">
              <i className={d.icon}></i> <span> {d.title} </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { is_toggle: false };
  }

  componentDidMount() {
    new MetisMenu("#side-menu");

    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname.includes(items[i].pathname)) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("mm-active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active"); // li
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <div className="left side-menu">
          {this.props.is_toggle ? (
            <PerfectScrollbar>
              <SideNav />
            </PerfectScrollbar>
          ) : (
            <SideNav />
          )}
          <div className="clearfix"></div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const is_toggle = makeLayoutSelectField("is_toggle");
  return { is_toggle };
};

export default withRouter(connect(mapStatetoProps, { toggleSidebar })(Sidebar));
